import * as routes from '../constants/routes';

const routeItems = [
  {
    path: routes.DASHBOARD,
    component: 'Dashboard',
    policy: 'dashboard.index',
  },

  {
    policy: 'order.index',
    path: routes.ORDER,
    component: 'Orders',
  },

  {
    policy: 'order.view',
    path: routes.ORDER_VIEW,
    component: 'Orders/View',
  },

  {
    policy: 'product.index',
    path: routes.PRODUCTS,
    component: 'Products',
  },
  {
    policy: 'product.view',
    path: routes.PRODUCT_VIEW,
    component: 'Products/View',
  },
  {
    policy: 'product.edit',
    path: routes.PRODUCT_EDIT,
    component: 'Products/Edit',
  },

  {
    policy: 'product.create',
    path: routes.PRODUCT_CREATE,
    component: 'Products/Create',
  },
  {
    policy: 'categories.index',
    path: routes.CATEGORIES,
    component: 'Categories',
  },
  {
    policy: 'categories.create',
    path: routes.CATEGORY_CREATE,
    component: 'Categories/Create',
  },
  {
    policy: 'offers.index',
    path: routes.OFFERS,
    component: 'Offers',
  },
  {
    policy: 'coupons.index',
    path: routes.COUPONS,
    component: 'Coupons',
  },
  {
    policy: 'advertisements.index',
    path: routes.ADVERTISEMENTS,
    component: 'Advertisements',
  },
  {
    policy: 'advertisements.index',
    path: routes.LANDING_IMAGES,
    component: 'LandingImages',
  },
  {
    policy: 'users.index',
    path: routes.USERS,
    component: 'Users',
  },
  {
    policy: 'reviews.index',
    path: routes.REVIEWS,
    component: 'Reviews',
  },
  {
    policy: 'subscriptions.index',
    path: routes.SUBSCRIPTIONS,
    component: 'Subscriptions',
  },
  {
    policy: 'role.index',
    path: routes.ROLES,
    component: 'Roles',
  },
  {
    policy: 'customers.index',
    path: routes.CUSTOMERS,
    component: 'Customers',
  },
  {
    policy: 'inquiries.index',
    path: routes.INQUIRIES,
    component: 'Inquiries',
  },
  {
    policy: 'default.index',
    path: routes.DEFAULTSETTINGS,
    component: 'DefaultSettings',
  },
];

export default routeItems;
